import { useEffect, useState } from 'react';
import { TEAM_FACTION_NAMES, DISPLAY_TEAM_BORDER } from '../displayTheme';

type TeamColor = 'BLUE' | 'RED' | 'GREEN' | 'YELLOW';

interface CompletedBond {
  id: string;
  fromTeam: TeamColor;
  fromHero: string;
  fromHeroImage?: string;
  bondText: string;
}

interface BondAllWinnersDisplayProps {
  sessionId: string;
}

function BondAllWinnersDisplay({ sessionId }: BondAllWinnersDisplayProps) {
  const [bonds, setBonds] = useState<CompletedBond[]>([]);

  useEffect(() => {
    const fetchBonds = async () => {
      try {
        const response = await fetch(`/api/bond-votes/session/${sessionId}/completed`);
        if (response.ok) {
          const data = await response.json();
          setBonds(data.bonds || []);
        }
      } catch (error) {
        console.error('[BondAllWinnersDisplay] Error fetching bonds:', error);
      }
    };

    fetchBonds();
  }, [sessionId]);

  // Calculate grid layout based on number of bonds
  const gridCols = bonds.length <= 2 ? 'grid-cols-2' : bonds.length <= 4 ? 'grid-cols-2' : 'grid-cols-3';

  return (
    <div className="h-screen w-screen display-dark-bg p-8 flex flex-col">
      {/* Title */}
      <h1 className="text-5xl font-bold text-parchment-100 font-display text-center mb-8">
        I Legami degli Eroi
      </h1>

      {/* Bonds Grid */}
      <div className={`flex-1 grid ${gridCols} gap-6 max-w-6xl mx-auto w-full`}>
        {bonds.map((bond) => (
          <div
            key={bond.id}
            className={`display-card border-2 ${DISPLAY_TEAM_BORDER[bond.fromTeam]} flex flex-col items-center justify-center`}
          >
            {/* Hero Image */}
            {bond.fromHeroImage && (
              <img
                src={bond.fromHeroImage}
                alt={bond.fromHero}
                className="w-32 h-32 object-cover rounded-xl mb-4 border-2 border-parchment-500/40"
              />
            )}

            {/* Hero Name */}
            <h2 className="text-3xl font-bold text-parchment-100 font-heading mb-2 text-center">
              {bond.fromHero}
            </h2>

            {/* Team */}
            <p className="text-2xl text-parchment-400 font-body mb-4">
              Squadra {TEAM_FACTION_NAMES[bond.fromTeam]}
            </p>

            {/* Bond Text */}
            <div className="bg-white/5 rounded-xl p-4 w-full">
              <p className="text-xl text-yellow-300 font-heading text-center italic">
                {bond.bondText}
              </p>
            </div>
          </div>
        ))}
      </div>

      {bonds.length === 0 && (
        <div className="flex-1 flex items-center justify-center">
          <p className="text-2xl text-parchment-400">Nessun legame ancora scelto</p>
        </div>
      )}
    </div>
  );
}

export default BondAllWinnersDisplay;
